import Client from '../../../../api/client';
import { inject } from 'aurelia-framework';
import { FlashService } from '../../../../flash/flash-service';
import { DialogView } from '../../../../view/dialog-view';
import { DialogService } from 'aurelia-dialog';

@inject(Client, FlashService, DialogService)
export class BussMailPlannerService {
    constructor(client, flash, dialog) {
        this.client = client;
        this.flash = flash;
        this.flash.hideAutomatically = true;
        this.dialog = dialog;
        this.selectedPin = [];
        this.handlePinEditSubmit = this.handlePinEditSubmit.bind(this);
    }

    async handlePinEditSubmit(form, object, googleMaps) {
        const values = form.formService.getValue();
        const data = {
            routeItinerary: values.routeItinerary,
            mailingPlanner: {
                id: object.id,
                modelId: 'humboldt/mailing-planner',
            },
            busStops: this.selectedPin,
        };

        try {
            const response = await this.client.post(
                `event-planner/update-bus-stops`,
                data
            );

            if (response.ok) {
                this.flash.success('Die Routen wurden aktualisiert');
                this.selectedPin = [];
            }
        } catch (error) {
            console.error(error);
            this.flash.error(
                error?.data?.localizedMessage ||
                    'Fehler beim Aktualisieren des Pins'
            );
        }
    }
}
